import { render, staticRenderFns } from "./ManageRiskAreaListView.vue?vue&type=template&id=5a93fff7"
import script from "./ManageRiskAreaListView.vue?vue&type=script&lang=ts"
export * from "./ManageRiskAreaListView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports